import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useApiClient } from '../useApiClient';
import { useTranslations } from '../useTranslations';
import type { TiassistoAddBookingResponseDTO } from '../../api/models/TiassistoModels/TiassistoAddBookingResponseDTO';
import type { TiassistoAddBookingRequestDTO } from '../../api/models/TiassistoModels/TiassistoAddBookingRequestDTO';
import toaster from '../../utils/toaster';

const useAddBooking = (licensePlate, onClose) => {
  const queryClient = useQueryClient();
  const { apiClient, handleApi } = useApiClient();
  const { t, i18nT } = useTranslations()

  const { mutate: addBooking, data: savePudResponse, isPending: isSavePudPending, error: isSavePudError } = useMutation<TiassistoAddBookingResponseDTO, Error, TiassistoAddBookingRequestDTO>({
    // retry: true,
    mutationFn: (payload: TiassistoAddBookingRequestDTO) => apiClient.tiassistoController.addBooking(payload),

    onSuccess: (response) => {
      if (!response.pudId) {
        toaster.error(response?.message);
      } else {
        toaster.success(t('new_pud_created_success'));
      }

      queryClient.invalidateQueries({ queryKey: ['activePudList'] });

      if (onClose) {
        onClose();
      }
    },
    onError: (error) => {
      console.error('Error creating booking:', error.message);
      toaster.error(error.message ?? t('error_creatin_new_pud'));
    },
    onSettled: () => {
    },
  });

  return { addBooking, savePudResponse, isSavePudPending, isSavePudError };
};

export default useAddBooking;
